import { Button, Select, Table } from "antd";
import TextArea from "antd/lib/input/TextArea";
import useAPI from "hooks/API";
import * as React from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useSelector } from "store";
import "./DeletedPortfolio.less";
import { setError } from "../../../../reducers/message";
import useContentSearch from "hooks/useContentSearch";

const columns = [
  {
    dataIndex: "id",
    title: "Portfolio",
    render: (id: any, { userList }: any) => {
      return <Link to={`/portfolios/${id}`}>{userList[0].name}</Link>;
    },
  },
  {
    dataIndex: "userList",
    title: "User",
    render: (userList: any) => {
      return userList[0].id;
    },
  },
];
const expandableTableColumns = [
  { dataIndex: "assetId", title: "Asset" },
  { dataIndex: "amount", title: "Amount" },
];

export default function DeletedPortfolio() {
  const [isSearching, setSearching] = React.useState<boolean>(false);
  const api = useAPI();
  const [data, setData] = React.useState<any>([]);
  const [userId, setUserId] = React.useState<string>();
  React.useEffect(() => {
    onSearch(userId);
  }, [userId]);
  const onSearch = (userId?: string) => {
    setSearching(true);
    api.get(`/admin/portfolios/deleted`, { userId }).then(({ result }) => {
      setData(result);
      setSearching(false);
    });
  };
  return (
    <div className="find-portfolio-page-container">
      <TextArea
        onChange={(event) => {
          setUserId(event.target.value);
        }}
        autoSize
        placeholder="User ID"
      ></TextArea>
      <Table
        loading={isSearching}
        columns={[
          ...columns,
          {
            dataIndex: "id",
            title: "Recover",
            render: (id: any) => {
              return (
                <Button
                  disabled={false}
                  onClick={() => {
                    api
                      .post(`/admin/portfolios/recover/${id}`)
                      .then(() => {
                        onSearch(userId);
                      });
                  }}
                  type="primary"
                >
                  Recover
                </Button>
              );
            },
          },
        ]}
        expandable={{
          expandedRowRender: ({ assets }) => (
            <div className="expanded-row">
              <Table
                columns={expandableTableColumns}
                rowKey={"assetId"}
                dataSource={Object.entries(assets).map(
                  ([assetId, { amount }]: any) => ({ assetId, amount })
                )}
              />
            </div>
          ),
        }}
        rowKey="id"
        dataSource={data}
      />
    </div>
  );
}
